import { Injectable } from '@angular/core';
import { BaseService } from '@app/core/services/base/base.service';
import { DrCurrencyFormat, DrI18nService } from '@app/core/services/i18n/i18n.service';
import { AuthenticationService } from '@app/core/authentication';

@Injectable({
    providedIn: 'root'
})
export class CurrencyService extends BaseService {

    get clientLocaleCurrency(): DrCurrencyFormat {
        return this.authenticationService.currentUserValue.client.locale ? {
            currency_code: this.authenticationService.currentUserValue.client.locale.currency_code,
            currency_display_name: this.authenticationService.currentUserValue.client.locale.currency_display_name,
            currency_fraction_digits: this.authenticationService.currentUserValue.client.locale.currency_fraction_digits,
            currency_symbol: this.authenticationService.currentUserValue.client.locale.currency_symbol,
            decimal_separator: this.authenticationService.currentUserValue.client.locale.decimal_separator,
            thousands_separator: this.authenticationService.currentUserValue.client.locale.thousand_separator
        } : null;
    }

    get localeCurrency(): DrCurrencyFormat {
        return DrI18nService.getActiveLocaleInformation().currencyFormats;
    }

    get activeCurrency(): DrCurrencyFormat {
        return this.hasAllRequiredValues(this.localeCurrency) ? this.localeCurrency : this.clientLocaleCurrency;
    }

    constructor(protected authenticationService: AuthenticationService, protected drI18nService: DrI18nService) {
        super();
    }

    private hasAllRequiredValues(format: DrCurrencyFormat): boolean {
        return !!format &&
               !!format.currency_code &&
               !!format.currency_display_name &&
               !!format.currency_fraction_digits &&
               !!format.currency_symbol &&
               !!format.decimal_separator &&
               !!format.thousands_separator;
    }
}

